import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useFloorsStore, useLocationsStore, useUsersStore } from '@/stores';
import { t } from '@/plugins/i18n';
import EditFloorplanButtons from '@/components/AppHeader/EditFloorplanButtons.vue';
import SearchComponent from '@/components/AppHeader/SearchComponent.vue';
import SelectWrappers from '@/components/AppHeader/SelectWrappers.vue';
import { useDeleteDialog } from './useDeleteFloorplanDialog';
import router from "@/service/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const floors = useFloorsStore();
const deleteDialog = useDeleteDialog();
const locationsStore = useLocationsStore();
const usersStore = useUsersStore();

// MENU
const menuItems = computed(() => {
  const items = [
    { name: 'Add new floor plan', disabled: !usersStore.isUserAdmin, value: 'navigateToAdd' },
    { name: 'Edit floor plan', disabled: !usersStore.isUserAdmin, value: 'navigateToEdit' },
    { name: 'Settings', disabled: !usersStore.isUserAdmin, value: 'navigateToSettings' },
    { name: 'Delete floor plan', disabled: !usersStore.isUserAdmin, value: 'navigateToDelete', warning: true }
  ];

  const filteredItems = items.filter((menuItem) => {
    switch (menuItem.value) {
      case 'navigateToEdit':
      case 'navigateToSettings':
      case 'navigateToDelete':
        return !!floors.currentFloor;
      default:
        return true;
    }
  });

  return filteredItems;
})

const dropDownMenuAction = (option: string) => {
  switch (option) {
    case 'navigateToEdit':
      floors.$patch({isEditCamerasFloorEnabled: true});
      break;
    case 'navigateToDelete':
      deleteDialog.createDeleteDialog();
    break;
    case 'navigateToAdd':
      router.push(`/new-floor-plan`);
      break;
    case 'navigateToSettings':
      floors.$patch({isEditSettingsActive: true});
      break;
  }
}


return { __sfc: true,floors, deleteDialog, locationsStore, usersStore, menuItems, dropDownMenuAction, t, EditFloorplanButtons, SearchComponent, SelectWrappers }
}

})